import { Validators } from '@angular/forms';
import { ControlValidators } from 'src/app/shared/validators/control.validators';
import { GroupValidators } from 'src/app/shared/validators/group.validators';

export class NewsValidators {
  public static readonly DESCRIPTION_LENGTH = 12000;
  public static readonly TITLE_LENGTH = 120;

  public static title = Validators.compose([Validators.required, Validators.maxLength(this.TITLE_LENGTH)])!;

  public static date = Validators.compose([Validators.required, ControlValidators.dateFromFutureOrToday])!;

  public static datesRange = GroupValidators.endDateGreater('dateFrom', 'dateTo');

  public static meetingRange = GroupValidators.endDateGreater('meetingFrom', 'meetingTo');
}
